import { CancelToken } from 'api';
import { get } from 'features/api';
import {
  ProductMainInfo,
  FetchProductMediaProps,
  FetchProductMediaResponse,
  BaseGetProps,
  MerchantInfo,
  CalculatorParameters,
} from '../types';

export function* fetchProductMainInfo(
  props: BaseGetProps,
  cancelToken?: CancelToken,
  path = 'get-product-main-info',
) {
  return yield* get<ProductMainInfo>(path, { ...props }, { cancelToken }); // hardcoded definition for testing
}

export const fetchProductMedia = (props: FetchProductMediaProps, cancelToken?: CancelToken) => {
  return get<FetchProductMediaResponse>('get-product-media', { ...props }, { cancelToken });
};

export const fetchProductMerchantInfo = (pid: string, regionId: string, cancelToken?: CancelToken) => {
  return get<MerchantInfo>('get-merchant-info', { pid, regionId }, { cancelToken });
};

export const fetchProductCalculatorParameters = (
  productId: string,
  regionId: string,
  cancelToken?: CancelToken,
) => {
  return get<CalculatorParameters>(`getParametersCalculator/${productId}`, { regionId }, { cancelToken });
};
